import { template as _$template } from "solid-js/web";
import { delegateEvents as _$delegateEvents } from "solid-js/web";
import { setAttribute as _$setAttribute } from "solid-js/web";
import { createComponent as _$createComponent } from "solid-js/web";
import { memo as _$memo } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
import { effect as _$effect } from "solid-js/web";
import { addEventListener as _$addEventListener } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<div class=duel__entry><button type=button class=duel__create data-testid=duel-create>OPEN A ROOM</button><p class=duel__or>or join one</p><div class=duel__join><input class=duel__code-input data-testid=duel-code-input placeholder="ROOM CODE"maxlength=8><button type=button class=duel__join-button data-testid=duel-join>JOIN`),
  _tmpl$2 = /*#__PURE__*/_$template(`<details class=duel__turn><summary>TURN relay (optional)</summary><p class=duel__turn-note>Only needed when both players are behind a NAT that STUN cannot punch through. This port ships the field, not a relay — paste your own server's URL and credentials and they stay in this browser.</p><label><span>URL</span><input data-testid=duel-turn-url placeholder=turns:relay.example:5349></label><label><span>Username</span><input></label><label><span>Credential</span><input type=password></label><button type=button>SAVE RELAY`),
  _tmpl$3 = /*#__PURE__*/_$template(`<fieldset class=duel__tier><legend>FLIGHT MODEL (the host's choice, for both)`),
  _tmpl$4 = /*#__PURE__*/_$template(`<button type=button class=duel__launch data-testid=duel-launch>START DUEL`),
  _tmpl$5 = /*#__PURE__*/_$template(`<div class=duel__room><p class=duel__code data-testid=duel-room-code>ROOM <strong></strong></p><p class=duel__share data-testid=duel-share-link></p><dl class=duel__facts><div><dt>You are</dt><dd data-testid=duel-role></dd></div><div><dt>Opponent</dt><dd data-testid=duel-opponent></dd></div></dl><p class=duel__launch-hint></p><div class=duel__actions><button type=button class=duel__leave data-testid=duel-leave>LEAVE ROOM`),
  _tmpl$6 = /*#__PURE__*/_$template(`<button type=button class=duel__tier-option>`),
  _tmpl$7 = /*#__PURE__*/_$template(`<section class=duel__panel><h1 class=duel__title>MULTIPLAYER DUEL</h1><p class=duel__blurb>One aeroplane each, head-on at 1,200 m. Both machines fly the identical simulation and swap only stick positions, so what you see is what he sees.</p><p class=duel__status data-testid=duel-status></p><fieldset class=duel__aircraft><legend>YOUR AEROPLANE</legend><select data-testid=duel-aircraft></select></fieldset><p class=duel__ice data-testid=duel-ice>`),
  _tmpl$8 = /*#__PURE__*/_$template(`<option>`);
import { For, Show } from "solid-js";
import { FLIGHT_MODEL_TIERS, aircraftLabel } from "@red-opus/engine";
import { describeIce } from "@red-opus/net";
import { canChooseAircraft, canLaunch, launchHint, lobbyNote } from "./duel-lobby.ts";
import { duelAircraftOptions } from "./duel-setup.ts";

/**
 * The pre-flight screen: open or join a room, pick an aeroplane, agree a
 * flight model, and see honestly what the connection is doing.
 *
 * Presentational only — every decision it renders comes from `duel-lobby.ts`,
 * which is a pure function of the connection's phase and therefore testable
 * without a socket.
 */

function RoomEntry(props) {
  return (() => {
    var _el$ = _tmpl$(),
      _el$2 = _el$.firstChild,
      _el$3 = _el$2.nextSibling,
      _el$4 = _el$3.nextSibling,
      _el$5 = _el$4.firstChild,
      _el$6 = _el$5.nextSibling;
    _$addEventListener(_el$2, "click", props.onCreate, true);
    _el$5.$$input = event => props.onRoomInput(event.currentTarget.value);
    _$addEventListener(_el$6, "click", props.onJoin, true);
    _$effect(() => _el$5.value = props.roomInput);
    return _el$;
  })();
}
function TurnFields(props) {
  return (() => {
    var _el$7 = _tmpl$2(),
      _el$8 = _el$7.firstChild,
      _el$9 = _el$8.nextSibling,
      _el$0 = _el$9.nextSibling,
      _el$1 = _el$0.firstChild,
      _el$10 = _el$1.nextSibling,
      _el$11 = _el$0.nextSibling,
      _el$12 = _el$11.firstChild,
      _el$13 = _el$12.nextSibling,
      _el$14 = _el$11.nextSibling,
      _el$15 = _el$14.firstChild,
      _el$16 = _el$15.nextSibling,
      _el$17 = _el$14.nextSibling;
    _el$10.$$input = event => props.onChangeTurn({
      ...props.turn,
      url: event.currentTarget.value
    });
    _el$13.$$input = event => props.onChangeTurn({
      ...props.turn,
      username: event.currentTarget.value
    });
    _el$16.$$input = event => props.onChangeTurn({
      ...props.turn,
      credential: event.currentTarget.value
    });
    _$addEventListener(_el$17, "click", props.onSaveTurn, true);
    _$effect(() => _el$10.value = props.turn.url);
    _$effect(() => _el$13.value = props.turn.username);
    _$effect(() => _el$16.value = props.turn.credential);
    return _el$7;
  })();
}
function RoomPanel(props) {
  return (() => {
    var _el$18 = _tmpl$5(),
      _el$19 = _el$18.firstChild,
      _el$20 = _el$19.firstChild,
      _el$21 = _el$20.nextSibling,
      _el$22 = _el$19.nextSibling,
      _el$23 = _el$22.nextSibling,
      _el$24 = _el$23.firstChild,
      _el$25 = _el$24.firstChild,
      _el$26 = _el$25.nextSibling,
      _el$27 = _el$24.nextSibling,
      _el$28 = _el$27.firstChild,
      _el$29 = _el$28.nextSibling,
      _el$32 = _el$23.nextSibling,
      _el$33 = _el$32.nextSibling,
      _el$35 = _el$33.firstChild;
    _$insert(_el$21, () => props.status.room);
    _$insert(_el$22, () => props.shareLink);
    _$insert(_el$26, () => props.status.role === "guest" ? "GUEST" : "HOST");
    _$insert(_el$29, (() => {
      var _c$ = _$memo(() => !!props.status.opponentAircraft);
      return () => _c$() ? aircraftLabel(props.status.opponentAircraft) : "—";
    })());
    _$insert(_el$18, _$createComponent(Show, {
      get when() {
        return props.status.role === "host";
      },
      get children() {
        var _el$30 = _tmpl$3(),
          _el$31 = _el$30.firstChild;
        _$insert(_el$30, _$createComponent(For, {
          each: FLIGHT_MODEL_TIERS,
          children: tier => (() => {
            var _el$36 = _tmpl$6();
            _el$36.$$click = () => props.onChooseTier(tier);
            _$setAttribute(_el$36, "data-testid", `duel-tier-${tier}`);
            _$insert(_el$36, () => tier.toUpperCase());
            _$effect(() => _el$36.classList.toggle("duel__tier-option--active", !!(props.tier === tier)));
            return _el$36;
          })()
        }), null);
        return _el$30;
      }
    }), _el$32);
    _$insert(_el$32, () => launchHint(props.status));
    _$insert(_el$33, _$createComponent(Show, {
      get when() {
        return props.status.role === "host";
      },
      get children() {
        var _el$34 = _tmpl$4();
        _$addEventListener(_el$34, "click", props.onLaunch, true);
        _$effect(() => _el$34.disabled = !canLaunch(props.status));
        return _el$34;
      }
    }), _el$35);
    _$addEventListener(_el$35, "click", props.onLeave, true);
    return _el$18;
  })();
}
export function DuelLobby(props) {
  return (() => {
    var _el$37 = _tmpl$7(),
      _el$38 = _el$37.firstChild,
      _el$39 = _el$38.nextSibling,
      _el$40 = _el$39.nextSibling,
      _el$41 = _el$40.nextSibling,
      _el$42 = _el$41.firstChild,
      _el$43 = _el$42.nextSibling,
      _el$44 = _el$41.nextSibling;
    _$insert(_el$37, _$createComponent(Show, {
      get when() {
        return props.connected;
      },
      get fallback() {
        return _$createComponent(RoomEntry, props);
      },
      get children() {
        return _$createComponent(RoomPanel, props);
      }
    }), _el$40);
    _$insert(_el$40, () => lobbyNote(props.status));
    _el$43.addEventListener("change", event => props.onChooseAircraft(event.currentTarget.value));
    _$insert(_el$43, _$createComponent(For, {
      get each() {
        return duelAircraftOptions();
      },
      children: option => (() => {
        var _el$45 = _tmpl$8();
        _$insert(_el$45, () => option.label);
        _$effect(() => _el$45.value = option.key);
        return _el$45;
      })()
    }));
    _$insert(_el$44, () => describeIce(props.ice));
    _$insert(_el$37, _$createComponent(TurnFields, props), null);
    _$effect(() => _el$41.disabled = !canChooseAircraft(props.status));
    _$effect(() => _el$43.value = props.aircraft);
    return _el$37;
  })();
}
_$delegateEvents(["click", "input"]);